/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v1.0.0 of "Info Services"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */
import type { LocalInstituteListResponse } from '../models/LocalInstituteListResponse';
import type { LocalInstituteResponse } from '../models/LocalInstituteResponse';

import { clientOptionsFactory } from '../clientOptions';
import { apiClientRequest as __request } from '@api-client/base';
import type { ClientOptions } from '@api-client/base';

export class InstitutesService {

    /**
     * Returns information about local institute identified by ID.
     *
     * @returns LocalInstituteResponse Resource **Institute** with information about local institute.
     *
     * @throws ApiError
     */
    public static getInfoInstitutes({
        id,
    }: {
        /**
         * ID internal identifier of local institute used as part of URI.
         *
         */
        id: string
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static getInfoInstitutes({
        id,
    }: {
        /**
         * ID internal identifier of local institute used as part of URI.
         *
         */
        id: string
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<LocalInstituteResponse>;
    public static getInfoInstitutes({
        id
    }: {
        /**
         * ID internal identifier of local institute used as part of URI.
         *
         */
        id: string,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'GET',
            url: '/info/institutes/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Returns list of all local institutes.
     *
     * @returns LocalInstituteListResponse **Institute** list with information about local instituts.
     *
     * @throws ApiError
     */
    public static getInfoInstitutes1(
        clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
        public static getInfoInstitutes1(
            clientOptionsOverride?: Partial<ClientOptions>): Promise<LocalInstituteListResponse>;
            public static getInfoInstitutes1(
                clientOptionsOverride: Partial<ClientOptions> = {}
            ) {
                return __request(
                    {...clientOptionsFactory.get()(), ...clientOptionsOverride},
                    {
                        method: 'GET',
                        url: '/info/institutes',
                    });
                }

            }
